/* eslint-disable jira/filename-case */
import type { ComponentType } from 'react';
import type { ReactGadgetProps } from '@jira/global-pages__dashboard-react-gadgets-common/src/types.tsx';
import {
	lazyForPaint,
	type PreloadPriority,
	type LazyComponent,
} from '@atlassian/react-loosely-lazy';
import type { Cleanup } from '@atlassian/react-loosely-lazy/cleanup';
import type { CustomReportGadgetData } from '../../common/types.tsx';

export const LazyCustomReportGadgetView: LazyComponent<
	ComponentType<ReactGadgetProps<CustomReportGadgetData>>
> = lazyForPaint<ComponentType<ReactGadgetProps<CustomReportGadgetData>>>(
	() => import(/* webpackChunkName: "async-react-custom-report-gadget-view" */ './main.tsx'),
);

export const preload: (priority?: PreloadPriority) => Cleanup = LazyCustomReportGadgetView.preload;
